<template>
  <div class="pdf3_main">
    <header>
      <div>
        <h6>{{ $t("pdf.text34") }}</h6>
        <p>: {{ dataList.account_name }}</p>
        <p></p>
      </div>
      <div>
        <h6>{{ $t("pdf.text35") }}</h6>
        <p>
          : {{ dataList.account_number }} -
          {{ account_type == 3 ? "USDT" : "USDC" }}
        </p>
        <p></p>
      </div>
      <div>
        <h6>{{ $t("pdf.text36") }}</h6>
        <!-- <p v-if="dataList.startTime == 0">: -</p>
        <p v-else>: {{ dataList.startTime | getDate }}</p> -->
        <p>: {{ dataList.opening_balance }}</p>
      </div>
      <div>
        <h6>{{ $t("pdf.text37") }}</h6>
        <!-- <p v-if="dataList.endTime == 0">
          :
          {{ getDate2() }}
        </p>
        <p v-else>: {{ dataList.endTime | getDate }}</p> -->
        <p>: {{ dataList.ledger_balance }}</p>
      </div>
      <div>
        <h6>{{ $t("pdf.text38") }}</h6>
        <!-- <p v-if="dataList.endTime == 0">
          :
          {{ getDate2() }}
        </p>
        <p v-else>: {{ dataList.endTime | getDate }}</p> -->
        <p>: {{ dataList.available_balance }}</p>
      </div>
    </header>
    <main>
      <table>
        <tr class="tr ant-table-row">
          <th>
            <p>{{ $t("pdf.text20") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text21") }}</p>
          </th>
          <th>
            <p>{{ $t('bank_card.card_username') }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text22") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text23") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text24") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text15") }}</p>
            <p>({{ $t("pdf.text25") }})</p>
          </th>
        </tr>
        <tr class="tr ant-table-row" v-for="(item, index) in list" :key="index">
          <td>{{ item.c_time | getDate }}</td>
          <td>
            <div v-if="item.type == 1">
              <p>{{ $t("main2.title1") }}</p>
              <p>
                {{ $t("main2.type1") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type1") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 2">
              <p>{{ $t("main2.title1") }}</p>
              <p>
                {{ $t("main2.type2") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type2") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 11">
              <p>{{ $t("main2.title1") }}</p>
              <p>
                {{ $t("main2.type11") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type11") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 10">
              <p>{{ $t("main2.title1") }}</p>
              <p>
                {{ $t("main2.type10") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type10") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 3">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type3") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type3") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 12">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type12") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type12") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 4">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type4") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type4") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 5">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type5") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type5") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 6">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type6") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type6") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 7">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type7") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type7") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 8">
              <p>{{ $t("main2.title2") }}</p>
              <p>
                {{ $t("main2.type8") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type8") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 9">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type9") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type9") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 13">
              <p>{{ $t("main2.title4") }}</p>
              <p>
                {{ $t("main2.type13") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type13") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 14">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type14") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type14") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 15">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type15") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type15") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 16">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type16") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type16") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 17">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type17") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type17") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 18">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type18") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type18") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 19">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type19") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type19") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 20">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type20") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type20") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 21">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type21") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type21") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 22">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type22") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type22") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 23">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type23") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type23") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 24">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type24") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type24") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 25">
              <p>{{ $t("main2.title3") }}</p>
              <p>
                {{ $t("main2.type25") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type25") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 26">
              <p>{{ $t("main2.title1") }}</p>
              <p>
                {{ $t("main2.type26") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type26") }}</span>
              </p>
            </div>
            <div v-else-if="item.type == 27">
              <p>{{ $t("main2.title4") }}</p>
              <p>
                {{ $t("main2.type27") }}
                <span v-if="v_lan == 'ch'">{{ $t("type.type27") }}</span>
              </p>
            </div>
            <!-- type 3,4,5,6,7,8,12 卡号 -->
            <!-- type 2,10,11 显示name -->
            <!-- type 1,9,13 remark -->
            <!-- <div v-if="[3, 4, 5, 6, 7, 8, 12].includes(item.type)">
              <p>{{ $t("main.text767") }} {{ item.card_number }}</p>
            </div>
            <div v-else-if="[2, 10, 11].includes(item.type)">
              {{ item.name }}
            </div>
            <div>
              {{ item.remark }}
            </div> -->
          </td>
          <td>{{ item.card_username||"-" }}</td>
          <td>{{ item.tx_id }}</td>
          <td>
            <span v-if="item.action == 11">
              {{ item.amount }}
            </span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="item.action == 10">
              {{ item.amount }}
            </span>
            <span v-else>-</span>
          </td>
          <td>{{ item.balance }}</td>
        </tr>
        <tr class="ant-table-row none tr">
          <td></td>
          <td></td>
          <td>
            <h6>
              <p>{{ $t("pdf.text12") }}</p>
              <p>{{ $t("pdf.text39") }}</p>
            </h6>
          </td>
          <td>
            <h6>{{ dataList.totalWithdraw }}</h6>
            <h6>{{ dataList.withdrawCount }}</h6>
          </td>
          <td>
            <h6>{{ dataList.totalDeposit }}</h6>
            <h6>{{ dataList.depositCount }}</h6>
          </td>
          <td></td>
        </tr>
        <!-- <tr class="ant-table-row none">
          <td></td>
          <td></td>
          <td>
            <h6>总计数 Total Count</h6>
          </td>
          <td>
            <h6>{{ dataList.withdrawCount }}</h6>
          </td>
          <td>
            <h6>{{ dataList.depositCount }}</h6>
          </td>
          <td></td>
        </tr> -->
      </table>
    </main>
    <footer class="ant-table-row">
      <p>**{{ $t("pdf.text40") }}**</p>
    </footer>
  </div>
</template>

<script>
import { dateFormat } from "../../assets/function/ch_time";
export default {
  filters: {
    getDate(v) {
      return dateFormat(v, "d/m/Y");
    },
  },
  props: {
    dataList: {
      default: {},
    },
    list: {
      default: [],
    },
    account_type: {
      default: "",
    },
    // t_h_time: {},
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getDate2(v) {
      return dateFormat(new Date(v).getTime(), "d/m/Y");
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
/* a4纸的尺寸[595.28,841.89] */
footer {
  margin-top: 20px;
}
h5 {
  font-size: 22px;
}
h6 {
  font-size: 18px;
}
h4 {
  font-size: 16px;
  margin-top: 20px;
}
.pdf3_main {
  font-size: 14px;
  margin: 10px 30px;
  padding-bottom: 20px;
  // transform: scale(0.5);
  .headerLogo {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 100px;
      margin-bottom: 30px;
    }
  }
  header {
    border: 1px solid black;
    border-radius: 5px;
    padding: 10px;
    div {
      display: flex;
      justify-content: space-between;
      margin: 6px 0;
      h6 {
        width: 200px;
        font-size: 15px;
      }
      p:nth-child(2) {
        flex: 1;
      }
    }
  }

  main {
    margin-top: 20px;
    .tableHeader {
      margin-top: 20px;
      background: #00263a;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: white;
      font-weight: bold;
      align-items: center;
      p {
        margin: 10px;
        font-size: 16px;
      }
    }
    .tableHeader2 {
      // display: inline-block;
      // width: auto;
      // color: white;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      .tr th {
        border-bottom: 1px solid #000;
        padding: 5px;
        text-align: right;
        width: 13%;
      }
      tr td {
        text-align: right;
        width: 13%;
      }
      .tr th {
        background: #d0d3d4;
        padding: 5px;
      }
      tr:nth-child(odd) {
        background: #f5f6f6;
      }
      .none {
        background: white !important;
        h6 {
          padding: 0;
        }
      }
      tr td,
      tr h6 {
        padding: 5px;
        font-size: 14px;
      }
      tr td:nth-child(1) {
        text-align: left;
        width: 10%;
      }
      tr td:nth-child(2) {
        text-align: left;
        width: 20%;
      }
      tr td:nth-child(3) {
        text-align: left;
        width: 28%;
      }
      tr td:nth-child(6) {
        text-align: right;
        width: 16%;
      }
      tr th:nth-child(1) {
        text-align: left;
        width: 10%;
      }
      tr th:nth-child(2) {
        text-align: left;
        width: 20%;
      }
      tr th:nth-child(3) {
        text-align: left;
        width: 28%;
      }
      tr th:nth-child(6) {
        text-align: right;
        width: 16%;
      }
      .footer_tr td {
        padding-top: 20px;
      }
    }
  }
}
</style>
